<div class="new-feature-container fx-layout-row">
  <div class="new-feature-tilted-box">
    {{ 'LABEL.NEW_FEATURE'| translate }}

  </div>
  <div class="new-feature-message">
        {{ message }}
  </div>
  <div class="fx-flex"></div>
  <div class="fx-layout-col">
    <button (click)="dismiss()" class="close-button">
      <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
    </button>
      <button (click)="reloadPage()" class="reload-button" [matTooltip]="'BUTTON.LOAD_NEW_VERSION' | translate"
              matTooltipPosition="below">
      <mat-icon fontSet="mdi" fontIcon="mdi-reload"></mat-icon>
    </button>
  </div>
</div>
